import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action } from 'mobx';
import moment from 'moment';
import * as constants from '../../model/const';

import { SiteHeader } from '../component/SiteHeader';
import { SiteFooter } from '../component/SiteFooter';

import { BWStepBar } from '../component/BWStepBar';
import { BWReceipt } from '../component/BWReceipt';

import { fmtPrice, fmtPercent } from '../../model/formatters';
import translateBase from '../../translate';

function servicesWahlbar(aggServices) {
  return aggServices.joinedListing.filter(o => o.available.typeId === constants.SERVICE_TYPE.WAHLBAR);
}

function servicesObligatorisch(aggServices) {
  return aggServices.joinedListing.filter(o => o.available.typeId === constants.SERVICE_TYPE.OBLIGATORISCH);
}

function servicesBedingt(aggServices) {
  return aggServices.joinedListing.filter(o => o.available.typeId === constants.SERVICE_TYPE.BEDINGT);
}

function servicesBeiReservation(aggServices) {
  return aggServices.joinedListing.filter(o => o.available.typeId === constants.SERVICE_TYPE.BEIRESERVATION);
}

@observer
class ServiceItem extends React.Component {
  render() {
    const {
      selected,
      description,
      name,
      currency,
      fixedPrice,
      percentagePrice,
      offerPrice,
      canBeSelected,
      itemCount,
      onIncrease,
      onDecrease,
      canInc,
      canDec,
      price,
    } = this.props;
    return (
      <div className={"list-entry" + (selected ? " selected" : "") + (price < 0 ? " discount" : "")}>
        <div className="input">
          {name}
        </div>
        <div className="value">{!percentagePrice ? `${currency} ${fmtPrice(fixedPrice)}` : `${fmtPercent(percentagePrice)}%`}</div>
        {canBeSelected && <div className="amount">
          <input placeholder="0" value={itemCount} />
          <a className={"minus" + (canDec ? "" : " unselectable")} onClick={onDecrease}><i className="fa fa-minus"></i></a>
          <a className={"plus" + (canInc ? "" : " unselectable")} onClick={onIncrease}><i className="fa fa-plus"></i></a>
        </div>}
        <div className="price">{currency} {fmtPrice(price)}</div>
      </div>
    )
  }
}

@inject(stores => ({
  navigation: stores.app.navigation,
  vServices: stores.app.vServices,
  servicesForm: stores.app.servicesForm,
  rentalTransaction: stores.app.rentalTransaction,
  bestOffers: stores.app.bestOffers,
  aggServices: stores.app.aggServices,
  vBookingWizard: stores.app.vBookingWizard,
  businessUnit: stores.app.businessUnit,
}))
@observer
export class BWServices extends React.Component {
  componentDidMount() {
    window.sessionStorage.setItem('servicesPassed', 1);
  }

  getNextActionLink() {
    const { navigation } = this.props;
    switch (this.props.vBookingWizard.nextServicesAction) {
      case "Accessories":
        return <a id="btn-fwd-bwsvc" className="forward" onClick={navigation.goBWAccessories}>{this.translate("next", "Weiter")} <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
      case "PersonalData":
        return <a id="btn-fwd-bwsvc" className="forward" onClick={navigation.goBWPersonalData}>{this.translate("next", "Weiter")} <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
    }
  }

  render() {
    let translate = translateBase.bindPage('bw02Services');
    this.translate = translate;
    const { navigation, servicesForm, rentalTransaction, bestOffers, aggServices, businessUnit } = this.props;
    const currency = businessUnit.currencyName; //"CHF";
    const srvWahlbar = servicesWahlbar(aggServices);
    const srvObligatorisch = servicesObligatorisch(aggServices);
    const srvBedingt = servicesBedingt(aggServices);
    const srvBeiReservation = servicesBeiReservation(aggServices);
    return (
      <div>
        <SiteHeader />

        <BWStepBar activeStep={2} />

        <BWReceipt />

        <section className="wizard-container booking-view">
          <div className="wrapper">
            <div className="row wizard-content">
              <div className="column-12">
                <h3 className="mali-blue">{translate("services", "Dienstleistungen")}</h3>
                {srvWahlbar.length > 0 &&
                  <div className="services-entry wahlbar-services">
                    {srvWahlbar.map(service => <Observer>{() => {
                      return (
                        <ServiceItem
                          selected={service.inTransaction.price > 0}
                          description={service.available.description}
                          name={service.available.name}
                          currency={currency}
                          fixedPrice={service.available.fixedPrice}
                          percentagePrice={service.available.percentagePrice}
                          offerPrice={service.available.offerPrice}
                          canBeSelected={service.available.canBeSelected}
                          itemCount={servicesForm.values.get(service.available.id)}
                          onIncrease={() => servicesForm.incAmount(service.available.id)}
                          onDecrease={() => servicesForm.decAmount(service.available.id)}
                          canInc={servicesForm.canInc(service.available.id)}
                          canDec={servicesForm.canDec(service.available.id)}
                          price={service.inTransaction.price} />
                      )
                    }}</Observer>)}
                  </div>
                }
              </div>
            </div>

            <div className="row main-wizardbtns-container">
              <div className="column-6">
                <a className="back" onClick={navigation.goBWOfferDetails}><i className="fa fa-arrow-left" aria-hidden="true"></i> {translate("back", "Zurück")}</a>
              </div>
              <div className="column-6">
                {this.getNextActionLink()}
              </div>
            </div>

          </div>
        </section>

        <SiteFooter />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/view/BWServices.js